/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"

const ErrorBox = React.memo(props => (
  <span sx={{ bg: `danger`, mt: 1, color: `background`, padding: 1, borderRadius: 2 }}>{props.children}</span>
))

export default ErrorBox
